import * as React from 'react';
const { Popover } = require('@cvent/carina-popover');
const { InfoIcon, HomeIcon, UtencilsIcon, DollarSignIcon } = require('@cvent/carina-icon');

const _styles = require('./BudgetRangePopover.scss');

interface BudgetRangePopoverProps {
    webInteraction?: boolean;
    mobileInteraction?: boolean;
}

export const BudgetRangePopover = (props: BudgetRangePopoverProps) => {
    return (
        <Popover
            placement='top-end'
            // @ts-ignore
            trigger={({ targetProps, toggleOpen, isOpen }) => (
                <div
                    className={_styles.icon}
                    onMouseEnter={props.webInteraction ? toggleOpen : undefined}
                    onMouseLeave={props.webInteraction ? toggleOpen : undefined}
                    onClick={props.mobileInteraction ? toggleOpen : undefined}
                >
                    <InfoIcon size='m' color='#881155' />
                </div>
            )}
        >
            <div className={_styles.wrapper}>
                <div className={_styles.title}>Budget Estimate Includes:</div>
                <div className={_styles.content}>
                    <div className={_styles.item}>
                        <HomeIcon />
                        <div>Venue Rental Costs</div>
                    </div>
                    <div className={_styles.item}>
                        <UtencilsIcon />
                        <div>Food & Beverage Costs</div>
                    </div>
                    <div className={_styles.item}>
                        <DollarSignIcon />
                        <div>Taxes and Other Fees</div>
                    </div>
                </div>
            </div>
        </Popover>
    );
};
